module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 36
 ** module chunks = 0 1 2 3
 **/